import {
  Autocomplete,
  AutocompleteItem,
  AutocompleteProps,
} from "@heroui/react";
import { UseFormRegisterReturn } from "react-hook-form";
import { useAppSelector } from "@/hooks/useAppSelector.ts";
import { TicketCategory, TicketCategoryType } from "@/api/tickets/tickets.ts";
import { CodependentHandbookProps } from "../modals/modalBuilder";
import { useMemo } from "react";

export function CodependentCategoryHandbook(
  props: CodependentHandbookProps & AutocompleteProps<TicketCategory>,
) {
  const items = useAppSelector((state) => state.handbooks.ticketCategory);

  const finalItems = useMemo(() => {
    const type = props.deps[0] as TicketCategoryType;
    return items.filter((i) => i.type == type);
  }, [props.deps, items]);

  return (
    <Autocomplete
      defaultItems={finalItems}
      label="Категория"
      placeholder="Выберите категорию"
      variant="bordered"
      {...props}
    >
      {(item) => (
        <AutocompleteItem
          key={String(item.id)}
        >{`${item.display_name}`}</AutocompleteItem>
      )}
    </Autocomplete>
  );
}

export function NewCategoryHandbook(props: AutocompleteProps<TicketCategory>) {
  const items = useAppSelector((state) => state.handbooks.ticketCategory);

  return (
    <Autocomplete
      defaultItems={items}
      label="Категория"
      placeholder="Выберите категорию"
      variant="bordered"
      {...props}
    >
      {(item) => (
        <AutocompleteItem key={String(item.id)}>
          {item.display_name}
        </AutocompleteItem>
      )}
    </Autocomplete>
  );
}

export function CategoryHandbook({
  register,
  isInvalid,
  errorMessage,
  defaultSelectedKey,
}: {
  register: UseFormRegisterReturn;
  isInvalid: boolean;
  errorMessage: string;
  defaultSelectedKey?: string;
}) {
  const items = useAppSelector((state) => state.handbooks.ticketCategory);

  return (
    <Autocomplete
      {...register}
      defaultItems={items}
      label="Категория"
      placeholder="Выберите категорию"
      variant="bordered"
      isInvalid={isInvalid}
      errorMessage={errorMessage}
      defaultSelectedKey={defaultSelectedKey}
    >
      {(item) => (
        <AutocompleteItem
          key={String(item.id)}
        >{`${item.display_name}`}</AutocompleteItem>
      )}
    </Autocomplete>
  );
}
